'use client';

import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { Card } from '@/components/atoms/Card/Card';

export const availabilityLabels: { [key: string]: any } = {
  careHome: 'Rooms available',
  homeCare: 'Accepting clients',
};

const imgNoSelect = {
  userSelect: 'none',
  WebkitUserDrag: 'none',
  MozUserSelect: 'none',
  WebkitUserSelect: 'none',
  msUserSelect: 'none',
} as const;

export const FeatureBullets = ({ children }: { children?: ReactNode }) => (
  <Stack
    direction='row'
    sx={{
      m: 0,
      p: 0,
      gap: sp[8],
      typography: 'bodyBold',
      alignItems: 'center',
    }}
  >
    {children}
  </Stack>
);
export const FeatureBulletsItem = ({ children }: { children?: ReactNode }) => (
  <Box>{children}</Box>
);

export const CardBody = ({ children, ...props }: any) => (
  <Card {...props} color='none' elevation={0} isBordered={false}>
    <Box
      sx={{
        gap: 0,
        border: 0,
        background: 'none',
        display: 'flex',
        minWidth: '50%',
        flexDirection: 'column',
        m: '2px',
        boxShadow: 'none',
      }}
    >
      {children}
    </Box>
  </Card>
);

export const CardBody2 = ({ children }: { children?: ReactNode }) => (
  <Stack
    sx={{
      gap: sp[16],
      border: 0,
      background: 'none',
      pb: sp[16],
      boxShadow: 'none',
      typography: 'bodyMd',
      color: '#000000',
    }}
  >
    {children}
  </Stack>
);

export const CardDetails = ({ children }: { children?: ReactNode }) => (
  <Stack sx={{ flexGrow: 1, gap: sp[16], typography: 'bodyMd' }}>
    {children}
  </Stack>
);

export const CardHeader = ({ children }: { children?: ReactNode }) => (
  <Box
    sx={{
      position: 'relative',
      '& > img': {
        width: '100%',
        height: '200px',
        maxHeight: '200px',
        borderRadius: '10px',
        objectFit: 'cover',
        ...imgNoSelect,
      },
    }}
  >
    {children}
  </Box>
);

export const CardActions = ({ children }: { children?: ReactNode }) => (
  <Stack
    sx={{ mt: 'auto', borderTop: '1px solid #cbc5b9', pt: sp[24], gap: sp[16] }}
  >
    {children}
  </Stack>
);

export const ServiceName = ({ children }: { children?: ReactNode }) => (
  <Box sx={{ color: '#000000', typography: 'bodyXlSemibold' }}>{children}</Box>
);

export const ServiceAddress = ({ children }: { children?: ReactNode }) => (
  <Box sx={{ typography: 'bodyMd' }}>{children}</Box>
);

export const ServiceTypeChips = ({ children }: { children?: ReactNode }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: sp[8] }}>{children}</Box>
);

export const GuidanceLabel = ({ children }: { children?: ReactNode }) => (
  <Box sx={{ color: '#404042', typography: 'bodySm' }}>{children}</Box>
);

export const AvailabilityChipContainer = ({
  children,
}: {
  children?: ReactNode;
}) => (
  <Box sx={{ position: 'absolute', top: sp[8], right: sp[8] }}>{children}</Box>
);

export const NoteContent = ({ children }: { children?: ReactNode }) => (
  <Box
    sx={{
      borderRadius: sp[8],
      p: sp[8],
      border: '1px solid #cbc5b9',
      typography: 'bodySm',
    }}
  >
    {children}
  </Box>
);

export const ExpertNoteContainer = ({ children }: { children?: ReactNode }) => (
  <Stack>{children}</Stack>
);

export const NoteHeader = ({ children }: { children?: ReactNode }) => (
  <Stack direction='row' sx={{ gap: sp[8], pb: sp[8] }}>
    {children}
  </Stack>
);

export const NoteTitle = ({ children }: { children?: ReactNode }) => (
  <Box sx={{ typography: 'bodyMediumWeight' }}>{children}</Box>
);

export const CardFooter = ({
  children,
  $isMobile,
}: {
  children?: ReactNode;
  $isMobile?: boolean;
}) => (
  <Box
    sx={{
      display: 'flex',
      flex: 1,
      ...($isMobile
        ? {
            flexDirection: 'column',
            alignItems: 'end',
            justifyContent: 'end',
            gap: sp[16],
          }
        : { flexDirection: 'row', justifyContent: 'space-between' }),
    }}
  >
    {children}
  </Box>
);

export const CardHeaderWrapper = ({
  children,
  $isRow,
}: {
  children?: ReactNode;
  $isRow?: boolean;
}) => (
  <Box
    sx={{
      position: 'relative',
      ...($isRow && {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
      }),
    }}
  >
    {children}
  </Box>
);
